import * as ambassadorWixBookingsServicesV2Service from './bookings-services-v2-service-services.http.js';
import * as ambassadorWixBookingsServicesV2ServiceTypes from './bookings-services-v2-service-services.types.js';
import * as ambassadorWixBookingsServicesV2ServiceUniversalTypes from './bookings-services-v2-service-services.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createService(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.CreateServiceRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.CreateServiceRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.CreateServiceResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.CreateServiceResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.createService(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateServices(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.BulkCreateServicesRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.BulkCreateServicesRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.BulkCreateServicesResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.BulkCreateServicesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.bulkCreateServices(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/services/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getService(): __PublicMethodMetaInfo<
  'GET',
  { serviceId: string },
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.GetServiceRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.GetServiceRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.GetServiceResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.GetServiceResponse
> {
  const payload = { serviceId: ':serviceId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.getService(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/services/{serviceId}',
    pathParams: { serviceId: 'serviceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateService(): __PublicMethodMetaInfo<
  'PATCH',
  { serviceId: string },
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.UpdateServiceRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.UpdateServiceRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.UpdateServiceResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.UpdateServiceResponse
> {
  const payload = { service: { id: ':serviceId' } } as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.updateService(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/services/{service.id}',
    pathParams: { serviceId: 'serviceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateServices(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.BulkUpdateServicesRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.BulkUpdateServicesRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.BulkUpdateServicesResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.BulkUpdateServicesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.bulkUpdateServices(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/services/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateServicesByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.BulkUpdateServicesByFilterRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.BulkUpdateServicesByFilterRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.BulkUpdateServicesByFilterResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.BulkUpdateServicesByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.bulkUpdateServicesByFilter(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/services/update-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteService(): __PublicMethodMetaInfo<
  'DELETE',
  { serviceId: string },
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.DeleteServiceRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.DeleteServiceRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.DeleteServiceResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.DeleteServiceResponse
> {
  const payload = { serviceId: ':serviceId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.deleteService(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v2/services/{serviceId}',
    pathParams: { serviceId: 'serviceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteServices(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.BulkDeleteServicesRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.BulkDeleteServicesRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.BulkDeleteServicesResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.BulkDeleteServicesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.bulkDeleteServices(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/services/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteServicesByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.BulkDeleteServicesByFilterRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.BulkDeleteServicesByFilterRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.BulkDeleteServicesByFilterResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.BulkDeleteServicesByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.bulkDeleteServicesByFilter(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/services/delete-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryServices(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.QueryServicesRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.QueryServicesRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.QueryServicesResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.QueryServicesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.queryServices(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchServices(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.SearchServicesRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.SearchServicesRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.SearchServicesResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.SearchServicesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.searchServices(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryPolicies(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.QueryPoliciesRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.QueryPoliciesRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.QueryPoliciesResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.QueryPoliciesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.queryPolicies(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/policies/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryBookingForms(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.QueryBookingFormsRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.QueryBookingFormsRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.QueryBookingFormsResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.QueryBookingFormsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.queryBookingForms(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/booking-forms/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function countServices(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.CountServicesRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.CountServicesRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.CountServicesResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.CountServicesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.countServices(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/count',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryLocations(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.QueryLocationsRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.QueryLocationsRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.QueryLocationsResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.QueryLocationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.queryLocations(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/locations/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryCategories(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.QueryCategoriesRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.QueryCategoriesRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.QueryCategoriesResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.QueryCategoriesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.queryCategories(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/categories/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setServiceLocations(): __PublicMethodMetaInfo<
  'POST',
  { serviceId: string },
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.SetServiceLocationsRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.SetServiceLocationsRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.SetServiceLocationsResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.SetServiceLocationsResponse
> {
  const payload = { serviceId: ':serviceId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.setServiceLocations(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/{serviceId}/locations',
    pathParams: { serviceId: 'serviceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function enablePricingPlansForService(): __PublicMethodMetaInfo<
  'POST',
  { serviceId: string },
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.EnablePricingPlansForServiceRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.EnablePricingPlansForServiceRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.EnablePricingPlansForServiceResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.EnablePricingPlansForServiceResponse
> {
  const payload = { serviceId: ':serviceId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.enablePricingPlansForService(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/{serviceId}/pricing-plans/add',
    pathParams: { serviceId: 'serviceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function disablePricingPlansForService(): __PublicMethodMetaInfo<
  'POST',
  { serviceId: string },
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.DisablePricingPlansForServiceRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.DisablePricingPlansForServiceRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.DisablePricingPlansForServiceResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.DisablePricingPlansForServiceResponse
> {
  const payload = { serviceId: ':serviceId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.disablePricingPlansForService(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/{serviceId}/pricing-plans/remove',
    pathParams: { serviceId: 'serviceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setCustomSlug(): __PublicMethodMetaInfo<
  'POST',
  { serviceId: string },
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.SetCustomSlugRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.SetCustomSlugRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.SetCustomSlugResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.SetCustomSlugResponse
> {
  const payload = { serviceId: ':serviceId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.setCustomSlug(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/{serviceId}/slugs/custom',
    pathParams: { serviceId: 'serviceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function validateSlug(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.ValidateSlugRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.ValidateSlugRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.ValidateSlugResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.ValidateSlugResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.validateSlug(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/slugs/validate',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cloneService(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.CloneServiceRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.CloneServiceRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.CloneServiceResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.CloneServiceResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.cloneService(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/clone',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createAddOnGroup(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.CreateAddOnGroupRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.CreateAddOnGroupRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.CreateAddOnGroupResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.CreateAddOnGroupResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.createAddOnGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/add-on-groups/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteAddOnGroup(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.DeleteAddOnGroupRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.DeleteAddOnGroupRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.DeleteAddOnGroupResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.DeleteAddOnGroupResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.deleteAddOnGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/add-on-groups/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateAddOnGroup(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.UpdateAddOnGroupRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.UpdateAddOnGroupRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.UpdateAddOnGroupResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.UpdateAddOnGroupResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.updateAddOnGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/add-on-groups/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listAddOnGroupsByServiceId(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.ListAddOnGroupsByServiceIdRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.ListAddOnGroupsByServiceIdRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.ListAddOnGroupsByServiceIdResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.ListAddOnGroupsByServiceIdResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.listAddOnGroupsByServiceId(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/add-on-groups/list-add-on-groups-by-service-id',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setAddOnsForGroup(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.SetAddOnsForGroupRequest,
  ambassadorWixBookingsServicesV2ServiceTypes.SetAddOnsForGroupRequest,
  ambassadorWixBookingsServicesV2ServiceUniversalTypes.SetAddOnsForGroupResponse,
  ambassadorWixBookingsServicesV2ServiceTypes.SetAddOnsForGroupResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsServicesV2Service.setAddOnsForGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/services/add-on-groups/set-add-ons-for-group',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Service as ServiceOriginal,
  ServiceType as ServiceTypeOriginal,
  ServiceTypeWithLiterals as ServiceTypeWithLiteralsOriginal,
  Media as MediaOriginal,
  MediaItem as MediaItemOriginal,
  MediaItemItemOneOf as MediaItemItemOneOfOriginal,
  Image as ImageOriginal,
  V2Category as V2CategoryOriginal,
  Form as FormOriginal,
  FormSettings as FormSettingsOriginal,
  Payment as PaymentOriginal,
  PaymentRateOneOf as PaymentRateOneOfOriginal,
  RateType as RateTypeOriginal,
  RateTypeWithLiterals as RateTypeWithLiteralsOriginal,
  FixedPayment as FixedPaymentOriginal,
  Money as MoneyOriginal,
  CustomPayment as CustomPaymentOriginal,
  VariedPayment as VariedPaymentOriginal,
  SubscriptionPayment as SubscriptionPaymentOriginal,
  FrequencyType as FrequencyTypeOriginal,
  FrequencyTypeWithLiterals as FrequencyTypeWithLiteralsOriginal,
  FirstChargeDateType as FirstChargeDateTypeOriginal,
  FirstChargeDateTypeWithLiterals as FirstChargeDateTypeWithLiteralsOriginal,
  FullUpfrontPayment as FullUpfrontPaymentOriginal,
  PaymentOptions as PaymentOptionsOriginal,
  AddOnPaymentOptions as AddOnPaymentOptionsOriginal,
  AddOnPaymentOptionsWithLiterals as AddOnPaymentOptionsWithLiteralsOriginal,
  DiscountInfo as DiscountInfoOriginal,
  OnlineBooking as OnlineBookingOriginal,
  Conferencing as ConferencingOriginal,
  V2Location as V2LocationOriginal,
  V2LocationOptionsOneOf as V2LocationOptionsOneOfOriginal,
  LocationTypeEnumLocationType as LocationTypeEnumLocationTypeOriginal,
  LocationTypeEnumLocationTypeWithLiterals as LocationTypeEnumLocationTypeWithLiteralsOriginal,
  CommonAddress as CommonAddressOriginal,
  CommonAddressStreetOneOf as CommonAddressStreetOneOfOriginal,
  CommonStreetAddress as CommonStreetAddressOriginal,
  CommonAddressLocation as CommonAddressLocationOriginal,
  BusinessLocationOptions as BusinessLocationOptionsOriginal,
  CustomLocationOptions as CustomLocationOptionsOriginal,
  BookingPolicy as BookingPolicyOriginal,
  PolicyDescription as PolicyDescriptionOriginal,
  LimitEarlyBookingPolicy as LimitEarlyBookingPolicyOriginal,
  LimitLateBookingPolicy as LimitLateBookingPolicyOriginal,
  BookAfterStartPolicy as BookAfterStartPolicyOriginal,
  CancellationPolicy as CancellationPolicyOriginal,
  ReschedulePolicy as ReschedulePolicyOriginal,
  WaitlistPolicy as WaitlistPolicyOriginal,
  ParticipantsPolicy as ParticipantsPolicyOriginal,
  ResourcesPolicy as ResourcesPolicyOriginal,
  CancellationFeePolicy as CancellationFeePolicyOriginal,
  CancellationWindow as CancellationWindowOriginal,
  CancellationWindowFeeOneOf as CancellationWindowFeeOneOfOriginal,
  SaveCreditCardPolicy as SaveCreditCardPolicyOriginal,
  StaffSortingPolicy as StaffSortingPolicyOriginal,
  StaffSortingPolicyOptionsOneOf as StaffSortingPolicyOptionsOneOfOriginal,
  RankingOrder as RankingOrderOriginal,
  RankingOrderWithLiterals as RankingOrderWithLiteralsOriginal,
  SortingMethodType as SortingMethodTypeOriginal,
  SortingMethodTypeWithLiterals as SortingMethodTypeWithLiteralsOriginal,
  RankingOptions as RankingOptionsOriginal,
  CustomOptions as CustomOptionsOriginal,
  IntakeFormPolicy as IntakeFormPolicyOriginal,
  Timing as TimingOriginal,
  TimingWithLiterals as TimingWithLiteralsOriginal,
  CompletionRequirement as CompletionRequirementOriginal,
  CompletionRequirementWithLiterals as CompletionRequirementWithLiteralsOriginal,
  Schedule as ScheduleOriginal,
  AvailabilityConstraints as AvailabilityConstraintsOriginal,
  V2Duration as V2DurationOriginal,
  DurationRange as DurationRangeOriginal,
  DurationRangeConfigOneOf as DurationRangeConfigOneOfOriginal,
  UnitType as UnitTypeOriginal,
  UnitTypeWithLiterals as UnitTypeWithLiteralsOriginal,
  HourlyConfig as HourlyConfigOriginal,
  DailyConfig as DailyConfigOriginal,
  StaffMember as StaffMemberOriginal,
  StaffMediaItem as StaffMediaItemOriginal,
  StaffMediaItemItemOneOf as StaffMediaItemItemOneOfOriginal,
  StaffMemberDetails as StaffMemberDetailsOriginal,
  ResourceGroup as ResourceGroupOriginal,
  ResourceIds as ResourceIdsOriginal,
  ServiceResource as ServiceResourceOriginal,
  ServiceResourceSelectionOneOf as ServiceResourceSelectionOneOfOriginal,
  ResourceType as ResourceTypeOriginal,
  Slug as SlugOriginal,
  URLs as URLsOriginal,
  PageUrlV2 as PageUrlV2Original,
  ExtendedFields as ExtendedFieldsOriginal,
  SeoSchema as SeoSchemaOriginal,
  Keyword as KeywordOriginal,
  Tag as TagOriginal,
  Settings as SettingsOriginal,
  AddOnGroup as AddOnGroupOriginal,
  AddOnDetails as AddOnDetailsOriginal,
  TaxableAddress as TaxableAddressOriginal,
  TaxableAddressType as TaxableAddressTypeOriginal,
  TaxableAddressTypeWithLiterals as TaxableAddressTypeWithLiteralsOriginal,
  V2PhoneCall as V2PhoneCallOriginal,
  SetCustomSlugEvent as SetCustomSlugEventOriginal,
  ServicesUrlsChanged as ServicesUrlsChangedOriginal,
  DummyRequest as DummyRequestOriginal,
  DummyResponse as DummyResponseOriginal,
  Booking as BookingOriginal,
  BookingParticipantsInfoOneOf as BookingParticipantsInfoOneOfOriginal,
  MultiServiceBookingType as MultiServiceBookingTypeOriginal,
  MultiServiceBookingTypeWithLiterals as MultiServiceBookingTypeWithLiteralsOriginal,
  BookedEntity as BookedEntityOriginal,
  BookedEntityItemOneOf as BookedEntityItemOneOfOriginal,
  BookedSlot as BookedSlotOriginal,
  BookedResource as BookedResourceOriginal,
  ResourceTransparency as ResourceTransparencyOriginal,
  ResourceTransparencyWithLiterals as ResourceTransparencyWithLiteralsOriginal,
  Location as LocationOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  PhoneCall as PhoneCallOriginal,
  ResourceSelection as ResourceSelectionOriginal,
  SelectionMethod as SelectionMethodOriginal,
  SelectionMethodWithLiterals as SelectionMethodWithLiteralsOriginal,
  BookedSchedule as BookedScheduleOriginal,
  ContactDetails as ContactDetailsOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  CustomFormField as CustomFormFieldOriginal,
  ValueType as ValueTypeOriginal,
  ValueTypeWithLiterals as ValueTypeWithLiteralsOriginal,
  BookingStatus as BookingStatusOriginal,
  BookingStatusWithLiterals as BookingStatusWithLiteralsOriginal,
  PaymentStatus as PaymentStatusOriginal,
  PaymentStatusWithLiterals as PaymentStatusWithLiteralsOriginal,
  SelectedPaymentOption as SelectedPaymentOptionOriginal,
  SelectedPaymentOptionWithLiterals as SelectedPaymentOptionWithLiteralsOriginal,
  BookingSource as BookingSourceOriginal,
  Platform as PlatformOriginal,
  PlatformWithLiterals as PlatformWithLiteralsOriginal,
  Actor as ActorOriginal,
  ActorWithLiterals as ActorWithLiteralsOriginal,
  ParticipantNotification as ParticipantNotificationOriginal,
  CommonIdentificationData as CommonIdentificationDataOriginal,
  CommonIdentificationDataIdOneOf as CommonIdentificationDataIdOneOfOriginal,
  IdentityType as IdentityTypeOriginal,
  IdentityTypeWithLiterals as IdentityTypeWithLiteralsOriginal,
  FlowControlSettings as FlowControlSettingsOriginal,
  ParticipantChoices as ParticipantChoicesOriginal,
  ServiceChoices as ServiceChoicesOriginal,
  ServiceChoice as ServiceChoiceOriginal,
  ServiceChoiceChoiceOneOf as ServiceChoiceChoiceOneOfOriginal,
  Duration as DurationOriginal,
  MultiServiceBookingInfo as MultiServiceBookingInfoOriginal,
  BookedAddOn as BookedAddOnOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateServiceRequest as CreateServiceRequestOriginal,
  CreateServiceResponse as CreateServiceResponseOriginal,
  ValidateServiceRequest as ValidateServiceRequestOriginal,
  ValidateServiceResponse as ValidateServiceResponseOriginal,
  FieldViolation as FieldViolationOriginal,
  BulkCreateServicesRequest as BulkCreateServicesRequestOriginal,
  BulkCreateServicesResponse as BulkCreateServicesResponseOriginal,
  BulkServiceResult as BulkServiceResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  GetServiceRequest as GetServiceRequestOriginal,
  V2RequestedFields as V2RequestedFieldsOriginal,
  V2RequestedFieldsWithLiterals as V2RequestedFieldsWithLiteralsOriginal,
  GetServiceResponse as GetServiceResponseOriginal,
  GetServiceAvailabilityConstraintsRequest as GetServiceAvailabilityConstraintsRequestOriginal,
  GetServiceAvailabilityConstraintsResponse as GetServiceAvailabilityConstraintsResponseOriginal,
  ServiceAvailabilityConstraints as ServiceAvailabilityConstraintsOriginal,
  SplitInterval as SplitIntervalOriginal,
  UpdateServiceRequest as UpdateServiceRequestOriginal,
  UpdateServiceResponse as UpdateServiceResponseOriginal,
  BulkUpdateServicesRequest as BulkUpdateServicesRequestOriginal,
  MaskedService as MaskedServiceOriginal,
  BulkUpdateServicesResponse as BulkUpdateServicesResponseOriginal,
  BulkUpdateServicesByFilterRequest as BulkUpdateServicesByFilterRequestOriginal,
  BulkUpdateServicesByFilterResponse as BulkUpdateServicesByFilterResponseOriginal,
  DeleteServiceRequest as DeleteServiceRequestOriginal,
  V2ParticipantNotification as V2ParticipantNotificationOriginal,
  DeleteServiceResponse as DeleteServiceResponseOriginal,
  BulkDeleteServicesRequest as BulkDeleteServicesRequestOriginal,
  BulkDeleteServicesResponse as BulkDeleteServicesResponseOriginal,
  BulkDeleteServicesByFilterRequest as BulkDeleteServicesByFilterRequestOriginal,
  BulkDeleteServicesByFilterResponse as BulkDeleteServicesByFilterResponseOriginal,
  QueryServicesRequest as QueryServicesRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryServicesResponse as QueryServicesResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  SearchServicesRequest as SearchServicesRequestOriginal,
  CursorSearch as CursorSearchOriginal,
  CursorSearchPagingMethodOneOf as CursorSearchPagingMethodOneOfOriginal,
  Aggregation as AggregationOriginal,
  AggregationKindOneOf as AggregationKindOneOfOriginal,
  RangeBucket as RangeBucketOriginal,
  SortType as SortTypeOriginal,
  SortTypeWithLiterals as SortTypeWithLiteralsOriginal,
  SortDirection as SortDirectionOriginal,
  SortDirectionWithLiterals as SortDirectionWithLiteralsOriginal,
  MissingValues as MissingValuesOriginal,
  MissingValuesWithLiterals as MissingValuesWithLiteralsOriginal,
  IncludeMissingValuesOptions as IncludeMissingValuesOptionsOriginal,
  ScalarType as ScalarTypeOriginal,
  ScalarTypeWithLiterals as ScalarTypeWithLiteralsOriginal,
  ValueAggregation as ValueAggregationOriginal,
  ValueAggregationOptionsOneOf as ValueAggregationOptionsOneOfOriginal,
  NestedAggregationType as NestedAggregationTypeOriginal,
  NestedAggregationTypeWithLiterals as NestedAggregationTypeWithLiteralsOriginal,
  RangeAggregation as RangeAggregationOriginal,
  ScalarAggregation as ScalarAggregationOriginal,
  DateHistogramAggregation as DateHistogramAggregationOriginal,
  Interval as IntervalOriginal,
  IntervalWithLiterals as IntervalWithLiteralsOriginal,
  NestedAggregationItem as NestedAggregationItemOriginal,
  NestedAggregationItemKindOneOf as NestedAggregationItemKindOneOfOriginal,
  AggregationType as AggregationTypeOriginal,
  AggregationTypeWithLiterals as AggregationTypeWithLiteralsOriginal,
  NestedAggregation as NestedAggregationOriginal,
  GroupByAggregation as GroupByAggregationOriginal,
  GroupByAggregationKindOneOf as GroupByAggregationKindOneOfOriginal,
  SearchDetails as SearchDetailsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  SearchServicesResponse as SearchServicesResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  AggregationData as AggregationDataOriginal,
  ValueAggregationResult as ValueAggregationResultOriginal,
  RangeAggregationResult as RangeAggregationResultOriginal,
  NestedAggregationResults as NestedAggregationResultsOriginal,
  NestedAggregationResultsResultOneOf as NestedAggregationResultsResultOneOfOriginal,
  ValueResults as ValueResultsOriginal,
  RangeResults as RangeResultsOriginal,
  AggregationResultsScalarResult as AggregationResultsScalarResultOriginal,
  NestedValueAggregationResult as NestedValueAggregationResultOriginal,
  ValueResult as ValueResultOriginal,
  RangeResult as RangeResultOriginal,
  ScalarResult as ScalarResultOriginal,
  ScalarDateResult as ScalarDateResultOriginal,
  NestedResultValue as NestedResultValueOriginal,
  NestedResultValueResultOneOf as NestedResultValueResultOneOfOriginal,
  Results as ResultsOriginal,
  DateHistogramResult as DateHistogramResultOriginal,
  GroupByValueResults as GroupByValueResultsOriginal,
  DateHistogramResults as DateHistogramResultsOriginal,
  NestedResults as NestedResultsOriginal,
  AggregationResultsScalarDateResult as AggregationResultsScalarDateResultOriginal,
  AggregationResults as AggregationResultsOriginal,
  AggregationResultsResultOneOf as AggregationResultsResultOneOfOriginal,
  QueryPoliciesRequest as QueryPoliciesRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  QueryPoliciesResponse as QueryPoliciesResponseOriginal,
  BookingPolicyWithServices as BookingPolicyWithServicesOriginal,
  QueryBookingFormsRequest as QueryBookingFormsRequestOriginal,
  RequestedFields as RequestedFieldsOriginal,
  RequestedFieldsWithLiterals as RequestedFieldsWithLiteralsOriginal,
  QueryBookingFormsResponse as QueryBookingFormsResponseOriginal,
  BookingForm as BookingFormOriginal,
  FormDetails as FormDetailsOriginal,
  ConnectedService as ConnectedServiceOriginal,
  CountServicesRequest as CountServicesRequestOriginal,
  CountServicesResponse as CountServicesResponseOriginal,
  QueryLocationsRequest as QueryLocationsRequestOriginal,
  QueryLocationsFilter as QueryLocationsFilterOriginal,
  QueryLocationsResponse as QueryLocationsResponseOriginal,
  BusinessLocations as BusinessLocationsOriginal,
  CustomLocations as CustomLocationsOriginal,
  CustomerLocations as CustomerLocationsOriginal,
  QueryCategoriesRequest as QueryCategoriesRequestOriginal,
  QueryCategoriesFilter as QueryCategoriesFilterOriginal,
  QueryCategoriesResponse as QueryCategoriesResponseOriginal,
  QueryServicesMultiLanguageRequest as QueryServicesMultiLanguageRequestOriginal,
  QueryServicesMultiLanguageResponse as QueryServicesMultiLanguageResponseOriginal,
  SetServiceLocationsRequest as SetServiceLocationsRequestOriginal,
  RemovedLocationSessionsAction as RemovedLocationSessionsActionOriginal,
  RemovedLocationSessionsActionActionOptionsOneOf as RemovedLocationSessionsActionActionOptionsOneOfOriginal,
  Action as ActionOriginal,
  ActionWithLiterals as ActionWithLiteralsOriginal,
  MoveToNewLocationsOptions as MoveToNewLocationsOptionsOriginal,
  SetServiceLocationsResponse as SetServiceLocationsResponseOriginal,
  EnablePricingPlansForServiceRequest as EnablePricingPlansForServiceRequestOriginal,
  PricingPlanSelection as PricingPlanSelectionOriginal,
  EnablePricingPlansForServiceResponse as EnablePricingPlansForServiceResponseOriginal,
  InvalidPricingPlan as InvalidPricingPlanOriginal,
  DisablePricingPlansForServiceRequest as DisablePricingPlansForServiceRequestOriginal,
  DisablePricingPlansForServiceResponse as DisablePricingPlansForServiceResponseOriginal,
  SetCustomSlugRequest as SetCustomSlugRequestOriginal,
  SetCustomSlugResponse as SetCustomSlugResponseOriginal,
  ValidateSlugRequest as ValidateSlugRequestOriginal,
  ValidateSlugResponse as ValidateSlugResponseOriginal,
  InvalidSlugError as InvalidSlugErrorOriginal,
  InvalidSlugErrorWithLiterals as InvalidSlugErrorWithLiteralsOriginal,
  CloneServiceRequest as CloneServiceRequestOriginal,
  CloneServiceResponse as CloneServiceResponseOriginal,
  CloneErrors as CloneErrorsOriginal,
  CloneErrorsWithLiterals as CloneErrorsWithLiteralsOriginal,
  CategoryNotification as CategoryNotificationOriginal,
  Category as CategoryOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  CategoryNotificationEvent as CategoryNotificationEventOriginal,
  CategoryNotificationEventWithLiterals as CategoryNotificationEventWithLiteralsOriginal,
  Empty as EmptyOriginal,
  BenefitNotification as BenefitNotificationOriginal,
  Benefit as BenefitOriginal,
  EntryPass as EntryPassOriginal,
  Discount as DiscountOriginal,
  DiscountDiscountOneOf as DiscountDiscountOneOfOriginal,
  BenefitType as BenefitTypeOriginal,
  BenefitTypeWithLiterals as BenefitTypeWithLiteralsOriginal,
  Behavior as BehaviorOriginal,
  BehaviorBehaviorOneOf as BehaviorBehaviorOneOfOriginal,
  Event as EventOriginal,
  EventWithLiterals as EventWithLiteralsOriginal,
  UserDomainInfoChangedEvent as UserDomainInfoChangedEventOriginal,
  CrudType as CrudTypeOriginal,
  CrudTypeWithLiterals as CrudTypeWithLiteralsOriginal,
  HtmlSitePublished as HtmlSitePublishedOriginal,
  Page as PageOriginal,
  SitePropertiesNotification as SitePropertiesNotificationOriginal,
  SitePropertiesEvent as SitePropertiesEventOriginal,
  Properties as PropertiesOriginal,
  Categories as CategoriesOriginal,
  Locale as LocaleOriginal,
  V4Address as V4AddressOriginal,
  AddressHint as AddressHintOriginal,
  PlacementType as PlacementTypeOriginal,
  PlacementTypeWithLiterals as PlacementTypeWithLiteralsOriginal,
  GeoCoordinates as GeoCoordinatesOriginal,
  BusinessSchedule as BusinessScheduleOriginal,
  TimePeriod as TimePeriodOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  SpecialHourPeriod as SpecialHourPeriodOriginal,
  Multilingual as MultilingualOriginal,
  SupportedLanguage as SupportedLanguageOriginal,
  ResolutionMethod as ResolutionMethodOriginal,
  ResolutionMethodWithLiterals as ResolutionMethodWithLiteralsOriginal,
  ConsentPolicy as ConsentPolicyOriginal,
  Translation as TranslationOriginal,
  ChangeContext as ChangeContextOriginal,
  ChangeContextPayloadOneOf as ChangeContextPayloadOneOfOriginal,
  PropertiesChange as PropertiesChangeOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCloned as SiteClonedOriginal,
  CreateAddOnGroupRequest as CreateAddOnGroupRequestOriginal,
  CreateAddOnGroupResponse as CreateAddOnGroupResponseOriginal,
  DeleteAddOnGroupRequest as DeleteAddOnGroupRequestOriginal,
  DeleteAddOnGroupResponse as DeleteAddOnGroupResponseOriginal,
  UpdateAddOnGroupRequest as UpdateAddOnGroupRequestOriginal,
  UpdateAddOnGroupResponse as UpdateAddOnGroupResponseOriginal,
  ListAddOnGroupsByServiceIdRequest as ListAddOnGroupsByServiceIdRequestOriginal,
  ListAddOnGroupsByServiceIdResponse as ListAddOnGroupsByServiceIdResponseOriginal,
  AddOn as AddOnOriginal,
  AddOnAddOnInfoOneOf as AddOnAddOnInfoOneOfOriginal,
  AddOnGroupDetail as AddOnGroupDetailOriginal,
  SetAddOnsForGroupRequest as SetAddOnsForGroupRequestOriginal,
  SetAddOnsForGroupResponse as SetAddOnsForGroupResponseOriginal,
  CreateServiceValidationErrors as CreateServiceValidationErrorsOriginal,
  UpdateServiceValidationErrors as UpdateServiceValidationErrorsOriginal,
  QueryBookingFormsApplicationErrors as QueryBookingFormsApplicationErrorsOriginal,
  EnablePricingPlansForServiceApplicationErrors as EnablePricingPlansForServiceApplicationErrorsOriginal,
  DisablePricingPlansForServiceApplicationErrors as DisablePricingPlansForServiceApplicationErrorsOriginal,
  SetCustomSlugApplicationErrors as SetCustomSlugApplicationErrorsOriginal,
  SetCustomSlugValidationErrors as SetCustomSlugValidationErrorsOriginal,
  DeleteAddOnGroupApplicationErrors as DeleteAddOnGroupApplicationErrorsOriginal,
  UpdateAddOnGroupApplicationErrors as UpdateAddOnGroupApplicationErrorsOriginal,
  SetAddOnsForGroupApplicationErrors as SetAddOnsForGroupApplicationErrorsOriginal,
} from './bookings-services-v2-service-services.types.js';
